// export { default as ar } from './localization/ar';
export { default as de } from './localization/de';
export { default as en } from './localization/en';
export { default as es } from './localization/es';
export { default as fr } from './localization/fr';
// export { default as he } from './localization/he';
// export { default as hi } from './localization/hi';
// export { default as it } from './localization/it';
export { default as ja } from './localization/ja';
// export { default as kk } from './localization/kk';
export { default as ko } from './localization/ko';
export { default as pl } from './localization/pl';
export { default as pt } from './localization/pt';
export { default as 'pt-BR' } from './localization/pt-BR';
export { default as ru } from './localization/ru';
export { default as tr } from './localization/tr';
export { default as 'zh-CN' } from './localization/zh-CN';
export { default as 'zh-TW' } from './localization/zh-TW';
export { default as 'zh-HK' } from './localization/zh-HK';
